import { UrlService }                         from '../UrlService';
import { DetectDevice, DetectDeviceUAParser } from '../DeviceDetector';
import { Game }                               from '../../models/Game';
import { Analytics }                          from './Analytics';
import { ADO_BUILD_VERSION }                  from '../../../version';

const arenaVersion = 'AARP';
const buildVersion = ADO_BUILD_VERSION;

type KeyValue = {
    [key: string]: any
};

export type AnalyticsEvent = {
    name: string;
    data: KeyValue;
};

export type AnalyticsEventsPair = {
    ga: AnalyticsEvent;
    ai: AnalyticsEvent;
};

export function makeEventsPair(gaEvent: AnalyticsEvent, aiEvent: AnalyticsEvent): AnalyticsEventsPair {
    return {
        ga: gaEvent,
        ai: aiEvent
    } as AnalyticsEventsPair;
}

export enum AnalyticsEventAction {
    CLICK = 'Click',
    IMPRESSION = 'Impression',
    START = 'Start',
    QUERY = 'Query'
}

export class AnalyticsEventBuilder {
    private name = '';
    private options = {};

    baseEvent(): AnalyticsEventBuilder {
        this.add(this.getEventBaseParams());
        return this;
    }

    setGame(game: Game): AnalyticsEventBuilder {
        this.add({ game: game.slug });
        return this;
    }

    setNonInteraction(nonInteraction: boolean): AnalyticsEventBuilder {
        this.add({ nonInteraction });
        return this;
    }

    setEventAction(action: AnalyticsEventAction): AnalyticsEventBuilder {
        this.add({ action });
        return this;
    }

    setName(name: string) {
        this.name = name;
    }

    setCustom(key: string, value: any): AnalyticsEventBuilder {
        this.add({ [key]: value });
        return this;
    }

    setEventGaAction(action: string | number) {
        this.add({ action });
    }

    setEventGaCategory(category: string) {
        this.add({ category });
    }

    setEventGaLabel(label: string) {
        this.add({ label });
    }
    build() {
        return {
            name: this.name,
            data: { ...this.options }
        } as AnalyticsEvent;
    }

    private add(data: KeyValue = {}) {
        this.options = {
            ...this.options,
            ...data
        };
    }

    private getEventBaseParams(): KeyValue {
        const utmInfo = UrlService.getUtmInfo();

        return {
            domain: UrlService.domain,
            userType: Analytics.userType,
            ...utmInfo,
            pageType: UrlService.getPageType(),
            deviceType: DetectDevice(),
            deviceType2: DetectDeviceUAParser(),
            arenaVersion,
            buildVersion
        };
    }
}
